export { default } from './DecoratedUsageChart.container';
